import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService as NgxToastr } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastrService {

  constructor(
    private translation: TranslateService,
    private ngxToastr: NgxToastr,
  ) {
  }

  success(messageTranslationKey: string = 'TOASTR.SUCCESS.DEFAULTMESSAGE', titleTranslationKey?: string): void {
    const translation$ = this.getToastrTranslations(titleTranslationKey, messageTranslationKey);

    translation$.subscribe((translation) => {
        if (translation.hasOwnProperty(titleTranslationKey)) {
          const message = translation[messageTranslationKey];
          const title = translation[titleTranslationKey];

          this.ngxToastr.success(message, title);
        } else {
          this.ngxToastr.success(translation);
        }
      });
  }

  error(messageTranslationKey: string = 'TOASTR.ERROR.DEFAULTMESSAGE', titleTranslationKey?: string): void {
    const translation$ = this.getToastrTranslations(titleTranslationKey, messageTranslationKey);

    translation$.subscribe((translation) => {
        if (translation.hasOwnProperty(titleTranslationKey)) {
          const message = translation[messageTranslationKey];
          const title = translation[titleTranslationKey];

          this.ngxToastr.error(message, title);
        } else {
          this.ngxToastr.error(translation);
        }
      });
  }

  private getToastrTranslations(titleTranslationKey: string, messageTranslationKey: string): Observable<any> {
    if (!titleTranslationKey) {
      return this.translation.get(messageTranslationKey);
    }

    return this.translation.get([messageTranslationKey, titleTranslationKey]);
  }
}
